import React      from 'react';
import classNames from 'classnames';

const spinner = props => (
  <div className="w-100 text-center m-auto">
    <i className={classNames("sm-spinner fa-2x accent-text fas fa-circle-notch fa-spin", props.classes)} />
  </div>
);

export default spinner;
